import { Component } from '@angular/core';
import { SexualPerformanceComponent } from '@consultation-upsells/sexual-performance/sexual-performance.component';

@Component({
  selector: 'app-sexual-performance-peptide',
  imports: [SexualPerformanceComponent],
  templateUrl: './sexual-performance-peptide.component.html',
})
export class SexualPerformancePeptideComponent {}
